
const FlexViewOne = ({ children } : { children : JSX.Element[]}) => {
  return (
    <div className="flex-view-one">
        {children}
    </div>
  )
}

export default FlexViewOne